import React from "react";
import "./Date.scss";

type Props = {
  children: React.ReactNode;
  isDetail?: boolean;
};

const Date: React.FC<Props> = ({ children, isDetail }) => {
  return <div className={`Date ${isDetail ? "detail" : ""}`}>{children}</div>;
};

export default React.memo(Date);
